import "@fontsource/rubik"
import "@fontsource/rubik/600.css"
import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider
